import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EStatus } from 'src/app/project/shared/enums/status.enum';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterSingle,
  TAdvancedFilterStatus,
  TFilterStatusOptions,
} from '../../../../models/advanced-filter.model';
import { getAdvancedStatusValues } from './advanced-filter-status-utils';
import { advancedStatusOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-status',
  templateUrl: './advanced-filter-status.component.html',
  styleUrls: ['./advanced-filter-status.component.scss'],
  standalone: false,
})
export class AdvancedFilterStatusComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Input() ppIndex: number;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: EStatus[];
  option: TFilterStatusOptions;
  filter: TAdvancedFilterStatus;

  ADVANCED_FILTER_STATUS_OPTIONS = advancedStatusOptions;
  ADVANCED_FILTER_STATUS_VALUES = getAdvancedStatusValues();
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterStatus;

    this.value = this.filter.value ? this.filter.value : [];
    this.option = this.filter.option;

    this.ADVANCED_FILTER_STATUS_VALUES.forEach((status) => {
      status.selected = this.filter.value?.includes(status.value as EStatus);
    });
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    const value = newCondition.value as TFilterStatusOptions;
    if (
      (value === EAdvancedFilterOptions.IS || value === EAdvancedFilterOptions.IS_NOT) &&
      this.filter.value?.length
    ) {
      this.filter.value.length = 1;
      this.value = this.filter.value;

      this.ADVANCED_FILTER_STATUS_VALUES.forEach((priority) => {
        priority.selected = this.filter.value?.includes(priority.value as EStatus);
      });
    }

    this.ppFilter.operator = newCondition.operator;

    this.ppFilter.option = value;
    this.option = value;
    this.applyChanges();
  }

  changeFieldValue(newValue: TSelectOption): void {
    const value = newValue.value as EStatus;
    if (this.filter.value?.length) {
      this.ppFilter.value[0] = value;
    } else {
      this.ppFilter.value = [value];
    }

    this.applyChanges();
  }

  changeFieldValueMultiple(): void {
    this.filter.value = this.ADVANCED_FILTER_STATUS_VALUES.filter((value) => value.selected).map(
      (value) => value.value,
    ) as EStatus[];

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }
}
